import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import { epsconfig } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';


interface PageInfo {
    n: number
}

var GsbFlag: any;

interface EPSConfigViewProps {
    gsb: AxiosInstance,
    EPSConfig: epsconfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function EPSConfigView({ gsb, EPSConfig = {} as epsconfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: EPSConfigViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)

    const [ATI_USER, setATI_USER] = useState(false)
    const [SL_USER, setSL_USER] = useState(false)


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)

                setATI_USER(GsbFlag.ATI_USER)
                setSL_USER(GsbFlag.SL_USER)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    if (! ("d_EX_CLTYPE" in EPSConfig)) return null



    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>

                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
             
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label='Exclude Client Type (ACIMP)' labelFor="inputEX_CLTYPE">
                    <InputGroup readOnly value={EPSConfig.d_EX_CLTYPE} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Exclude NON CCASS Stocks" labelInfo="">
                    <RadioGroup
                        name="d_EX_NONCAS"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_EX_NONCAS}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            Exclude Stock Allocations :
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-3" label="1. Company - Street Name" labelInfo="">
                    <RadioGroup
                        name="d_EX_STRQTY"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_EX_STRQTY}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="2. Company - Nominee Name" labelInfo="">
                    <RadioGroup
                        name="d_EX_COMQTY"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_EX_COMQTY}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="3. CCASS - Street Name" labelInfo="">
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="4. CCASS - Nominee Name" labelInfo="">
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="5. Registry" labelInfo="">
                    <RadioGroup
                        name="d_EX_TDQTYS"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_EX_TDQTYS}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="6. Bank Custody" labelInfo="">
                    <RadioGroup
                        name="d_EX_BANQTY"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_EX_BANQTY}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="7. Other Allocations" labelInfo="">
                    <RadioGroup
                        name="d_EX_OTHQTY"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_EX_OTHQTY}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="To skip Matched Stocks in Checking Report" labelInfo="">
                    <RadioGroup
                        name="d_SKIP_MATCH"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_SKIP_MATCH}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            {ATI_USER && <div >Detail CCASS A/C</div> }
            <div className="Spacing-V-16" />
            {ATI_USER && <div className="Row">
                <FormGroup className="Col-1-3" label="Print out Detail CCASS A/C" labelInfo="">
                    <RadioGroup
                        name="d_PRN_SUBACC"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_PRN_SUBACC}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
            {ATI_USER && <div className="Row">
                <FormGroup className="Col-1-4" label="To skip Matched Stocks in Detail CCASS A/C Report" labelInfo="">
                    <RadioGroup
                        name="d_S_M_SUBACC"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_S_M_SUBACC}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            {SL_USER && <div className="Row">
                <FormGroup className="Col-1-4" label='To include other locations of "SL"' labelInfo="">
                    <RadioGroup
                        name="d_CHECK_SL"
                        disabled={true}
                        inline={true}
                        selectedValue={EPSConfig.d_CHECK_SL}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
        </div>
    )
}

interface EPSConfigEditProps {
    gsb: AxiosInstance,
    EPSConfig?: epsconfig,
    isNew?: boolean,
    onSave?: (EPSConfig: epsconfig) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function EPSConfigEdit({ gsb, EPSConfig = {} as epsconfig, isNew = false, onSave = () => { }, onCancel = () => { } }: EPSConfigEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<epsconfig>()

    const [EX_NONCASValue, setEX_NONCASValue] = useState(EPSConfig.d_EX_NONCAS)
    const [EX_STRQTYValue, setEX_STRQTYValue] = useState(EPSConfig.d_EX_STRQTY)
    const [EX_COMQTYValue, setEX_COMQTYValue] = useState(EPSConfig.d_EX_COMQTY)
    const [EX_TDQTYValue, setEX_TDQTYValue] = useState(EPSConfig.d_EX_TDQTYS)
    const [EX_BANQTYValue, setEX_BANQTYValue] = useState(EPSConfig.d_EX_BANQTY)
    const [EX_OTHQTYValue, setEX_OTHQTYValue] = useState(EPSConfig.d_EX_OTHQTY)
    const [SKIP_MATCHValue, setSKIP_MATCHValue] = useState(EPSConfig.d_SKIP_MATCH)
    const [PRN_SUBACCValue, setPRN_SUBACCValue] = useState(EPSConfig.d_PRN_SUBACC)
    const [S_M_SUBACCValue, setS_M_SUBACCValue] = useState(EPSConfig.d_S_M_SUBACC)
    const [CHECK_SLValue, setCHECK_SLValue] = useState(EPSConfig.d_CHECK_SL)

    const [ATI_USER, setATI_USER] = useState(false)
    const [SL_USER, setSL_USER] = useState(false)


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)

                setATI_USER(GsbFlag.ATI_USER)
                setSL_USER(GsbFlag.SL_USER)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        // Call reset to set default values if ac is passed
        if ("d_EX_CLTYPE" in EPSConfig) {
            reset(EPSConfig)
        }
    }, [EPSConfig, reset])

    
    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])

    
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    

    if (! isNew && !("d_EX_CLTYPE" in EPSConfig)) return null


    const onSubmit = (data: epsconfig) => {
        //console.log("onsubmit called", data)
        data.d_EX_CLTYPE = data.d_EX_CLTYPE.toUpperCase();

        data.d_EX_NONCAS = EX_NONCASValue;
        data.d_EX_STRQTY = EX_STRQTYValue;
        data.d_EX_COMQTY = EX_COMQTYValue;
        data.d_EX_TDQTYS = EX_TDQTYValue;
        data.d_EX_BANQTY = EX_BANQTYValue;
        data.d_EX_OTHQTY = EX_OTHQTYValue;
        data.d_SKIP_MATCH = SKIP_MATCHValue;
        data.d_PRN_SUBACC = PRN_SUBACCValue;
        data.d_S_M_SUBACC = S_M_SUBACCValue;
        data.d_CHECK_SL = CHECK_SLValue;

        (async () => {
            try {
                //console.log("call EPSConfigedit data", data)
                //console.log("call EPSConfigedit isNew", isNew)
                const res = await gsb.post('/Transaction', {sb_data: data, cPgmId: "Eps_Rpt", cAction: "EpsConfigValidate", isNew: isNew})
                //console.log("EPSConfigedit res.data.ok", res.data.ok)
                //console.log("EPSConfigedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()


    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label='Exclude Client Type (ACIMP)' labelFor="inputEX_CLTYPE">
                    <InputGroup id="inputEX_CLTYPE" name="d_EX_CLTYPE" defaultValue="" placeholder='Exclude Client Type (ACIMP) ...' inputRef={register({ maxLength: 10}) } />
                    {errors.d_EX_CLTYPE && errors.d_EX_CLTYPE.types && <span id="Err_msg">{errors.d_EX_CLTYPE.types.message}</span>}
                    {errors.d_EX_CLTYPE && errors.d_EX_CLTYPE.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Exclude NON CCASS Stocks" labelInfo="">
                    <RadioGroup
                        name="d_EX_NONCAS"
                        inline={true}
                        selectedValue={EX_NONCASValue}
                        onChange={utils.handleStringChange(s => setEX_NONCASValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_EX_NONCAS && errors.d_EX_NONCAS.types && <span id="Err_msg">{errors.d_EX_NONCAS.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            Exclude Stock Allocations :
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-3" label="1. Company - Street Name" labelInfo="">
                    <RadioGroup
                        name="d_EX_STRQTY"
                        inline={true}
                        selectedValue={EX_STRQTYValue}
                        onChange={utils.handleStringChange(s => setEX_STRQTYValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_EX_STRQTY && errors.d_EX_STRQTY.types && <span id="Err_msg">{errors.d_EX_STRQTY.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="2. Company - Nominee Name" labelInfo="">
                    <RadioGroup
                        name="d_EX_COMQTY"
                        inline={true}
                        selectedValue={EX_COMQTYValue}
                        onChange={utils.handleStringChange(s => setEX_COMQTYValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_EX_COMQTY && errors.d_EX_COMQTY.types && <span id="Err_msg">{errors.d_EX_COMQTY.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="3. CCASS - Street Name" labelInfo="">
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="4. CCASS - Nominee Name" labelInfo="">
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="5. Registry" labelInfo="">
                    <RadioGroup
                        name="d_EX_TDQTYS"
                        inline={true}
                        selectedValue={EX_TDQTYValue}
                        onChange={utils.handleStringChange(s => setEX_TDQTYValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_EX_TDQTYS && errors.d_EX_TDQTYS.types && <span id="Err_msg">{errors.d_EX_TDQTYS.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="6. Bank Custody" labelInfo="">
                    <RadioGroup
                        name="d_EX_BANQTY"
                        inline={true}
                        selectedValue={EX_BANQTYValue}
                        onChange={utils.handleStringChange(s => setEX_BANQTYValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_EX_BANQTY && errors.d_EX_BANQTY.types && <span id="Err_msg">{errors.d_EX_BANQTY.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="7. Other Allocations" labelInfo="">
                    <RadioGroup
                        name="d_EX_OTHQTY"
                        inline={true}
                        selectedValue={EX_OTHQTYValue}
                        onChange={utils.handleStringChange(s => setEX_OTHQTYValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_EX_OTHQTY && errors.d_EX_OTHQTY.types && <span id="Err_msg">{errors.d_EX_OTHQTY.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="To skip Matched Stocks in Checking Report" labelInfo="">
                    <RadioGroup
                        name="d_SKIP_MATCH"
                        inline={true}
                        selectedValue={SKIP_MATCHValue}
                        onChange={utils.handleStringChange(s => setSKIP_MATCHValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_SKIP_MATCH && errors.d_SKIP_MATCH.types && <span id="Err_msg">{errors.d_SKIP_MATCH.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            {ATI_USER && <div >Detail CCASS A/C</div> }
            <div className="Spacing-V-16" />
            {ATI_USER && <div className="Row">
                <FormGroup className="Col-1-3" label="Print out Detail CCASS A/C" labelInfo="">
                    <RadioGroup
                        name="d_PRN_SUBACC"
                        inline={true}
                        selectedValue={PRN_SUBACCValue}
                        onChange={utils.handleStringChange(s => setPRN_SUBACCValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_PRN_SUBACC && errors.d_PRN_SUBACC.types && <span id="Err_msg">{errors.d_PRN_SUBACC.types.message}</span>}
                </FormGroup>
            </div> }
            {ATI_USER && <div className="Row">
                <FormGroup className="Col-1-4" label="To skip Matched Stocks in Detail CCASS A/C Report" labelInfo="">
                    <RadioGroup
                        name="d_S_M_SUBACC"
                        inline={true}
                        selectedValue={S_M_SUBACCValue}
                        onChange={utils.handleStringChange(s => setS_M_SUBACCValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_S_M_SUBACC && errors.d_S_M_SUBACC.types && <span id="Err_msg">{errors.d_S_M_SUBACC.types.message}</span>}
                </FormGroup>
            </div> }
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            {SL_USER && <div className="Row">
                <FormGroup className="Col-1-4" label='To include other locations of "SL"' labelInfo="">
                    <RadioGroup
                        name="d_CHECK_SL"
                        inline={true}
                        selectedValue={CHECK_SLValue}
                        onChange={utils.handleStringChange(s => setCHECK_SLValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_CHECK_SL && errors.d_CHECK_SL.types && <span id="Err_msg">{errors.d_CHECK_SL.types.message}</span>}
                </FormGroup>
            </div> }
        </form>
    )
}

interface Eps_Rpt1MainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function Eps_Rpt1Main({ gsb }: Eps_Rpt1MainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as epsconfig[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as epsconfig)
    const [BlankAc, setBlankAc] = useState({} as epsconfig)


    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    const [ATI_USER, setATI_USER] = useState(false)

    //gsb default value
    //BlankAc.d_p_Pref = "P"



    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("Eps_Rpt1Main disp user_key: ", res.data.Flag.user_key)
                //console.log("Eps_Rpt1Main disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("Eps_Rpt1Main disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("Eps_Rpt1Main disp GsbFlag: ", GsbFlag)
                //console.log("Eps_Rpt1Main disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("Eps_Rpt1Main disp dateFormat: ", dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("Eps_Rpt1Main disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("Eps_Rpt1Main disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("Eps_Rpt1Main disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                //console.log("Eps_Rpt1Main isProduction: ", GsbFlag.isProduction)
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                //console.log("set StatusList: ", StatusList)
                setATI_USER(GsbFlag.ATI_USER)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {

        console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01, currentMode])


    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                const res = await gsb.post('/Transaction',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "Eps_Rpt",
                        cAction: "ListRec",
                    });
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                console.log("main res.data", res.data.data)
                console.log("main currentAc", currentAc)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    const PrevRecProcess = async (EPSConfig: epsconfig) => {
    }

    const DeleteProcess = async (EPSConfig: epsconfig) => {
    }

    const NextRecProcess = async (EPSConfig: epsconfig) => {
    }

    const newOnSave = async (EPSConfig: epsconfig) => {
    }

    const editOnSave = async (EPSConfig: epsconfig) => {
        try {
            console.log("call editOnSave", EPSConfig)
            const res = await gsb.post('/Transaction', {sb_data: EPSConfig, cPgmId: "Eps_Rpt", cAction: "UpdateRec"})
            //showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record saved")
/*            
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
*/            
            //setCurrentAc(res.data.data)
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <EPSConfigView gsb={gsb} EPSConfig={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></EPSConfigView>
    switch (currentMode) {
        case "edit":
            detail = <EPSConfigEdit gsb={gsb} EPSConfig={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></EPSConfigEdit>
            break
        case "new":
            detail = <EPSConfigEdit gsb={gsb} EPSConfig={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></EPSConfigEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>EPS Setup</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default Eps_Rpt1Main